import React, { useCallback, useEffect, useState } from "react";
import cx from "classnames";
import Form from 'react-bootstrap/Form';
import { connect } from "react-redux";
import { Field, change, formValueSelector, reduxForm } from "redux-form";
import withStyles from "isomorphic-style-loader/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment-timezone";
import OrderItems from "../OrderItems/OrderItems";
import BookingReviewImageUpload from "../BookingReviewImageUpload/BookingReviewImageUpload";
import OrderAccordionItems from "../OrderAccordionItems/OrderAccordionItems";
import Loader from "../../Common/Loader/Loader";
import { uploadReviewImage } from "../../../actions/uploadReviewImage";
import { removeReviewImage } from "../../../actions/removeReviewImage";
import { openExactImageLightBox } from "../../../actions/siteadmin/ImageLightBox";
import { closeImageLightBox } from "../../../actions/siteadmin/ImageLightBox";
import InputFieldComponent from "../../Common/InputFieldComponent/InputFieldComponent";
import ShowDescription from "../../ShowDescription/ShowDescription";
import validate from "./validate";
import messages from "../../../locale/messages";
import { api, reviewImageUploadDir } from "../../../config";
import ImageSlider from "../../SiteAdmin/ImageSlider/ImageSlider";
import removeIcon from '/public/dashboard/removeIcon.svg';
import defaultIcon from '/public/dashboard/defaultIconMenu.svg';
import locationIcon from '/public/dashboard/locationIcon.svg';
import defaultDateIcon from '../../../../public/Icons/defaultDateIcon.svg';
import defaultHoverFrameIcon from '../../../../public/Icons/defaultHoverFrameIcon.svg';
import bt from '../../commonStyle.css';
import s from './OrderDetails.css';



function OrderDetails(props) {
    const {
        currentIndex,
        data,
        reviewPage,
        isOrderPage,
        change,
        reviewImageLoader,
        reviewImage,
        uploadReviewImage,
        removeReviewImage,
        intl: { formatMessage },
        isBooking,
        socket,
        id,
        openExactImageLightBox,
        closeImageLightBox,
        imageLightBox,
        refetch,
        isBillingPage
    } = props
    const [sources, setSources] = useState([]);
    const [setLoader, updateLoader] = useState([]);

    let reviewImages = data?.result?.reviewImage || [];
    let pricingType = isOrderPage ? data?.result?.categoryDetails?.pricingType : data?.result?.pricingType;
    let isJobPhotoRequired = data?.result?.categoryDetails?.isJobPhotoRequired;
    let dropLocation = isOrderPage ? data?.result?.orderItemsList[0]?.dropLocation : data?.result?.endLocation;
    let description = data?.result?.reviewDescription
    let createdAt = moment(parseInt(data?.result?.createdAt)).format('dddd, DD-MM-YYYY / h:mm A');

    useEffect(() => {
        if (data?.result?.reviewImage) {
            let sources = []
            data?.result?.reviewImage.forEach((item) => {
                sources.push(api.apiEndpoint + reviewImageUploadDir + item.imageName)
            });
            setSources(sources);
        }
    }, [data?.result?.reviewImage]);

    const success = async (fieldName) => {
        await change('reviewImage', fieldName)
        uploadReviewImage(data?.result?.id, fieldName)

    }

    const setImageLoader = (status) => {
        updateLoader(prev => {
            if (status == null) return [];
            const exists = prev.includes(status);
            if (exists) {
                return prev.filter(loaderFile => loaderFile !== status);
            } else {
                return [...prev, status];
            }
        });
    };
    const handleClick = useCallback((index) => {
        isBooking && openExactImageLightBox(index)
    })

    const renderUploadedImages = (reviewImages) => {
        if (isBooking) {
            const imagesToShow = reviewImages.slice(0, 6);
            const remainingCount = reviewImages.length - 6;
            return (
                <>
                    {imagesToShow?.map((image, index) => (
                        <div key={index} onClick={() => handleClick(index)} className={cx(s.orderUploadPreviewImgItem, (remainingCount >= 1 && index == 5) ? s.orderUploadPreviewTextHover : s.orderUploadPreviewImgHover)}>
                            <div
                                className={s.orderUploadPreviewImg}
                                style={{
                                    backgroundImage: `url(${api.apiEndpoint + reviewImageUploadDir + 'medium_' + image.imageName})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            />
                            <div className={s.orderUploadPreviewOverlay} />
                            {remainingCount >= 1 && index == 5 ?
                                <div className={cx(s.orderUploadPreviewCountText, bt.commonSize18, bt.fontWight700)}>
                                    +{remainingCount}
                                </div> :
                                <div className={s.orderUploadPreviewHoverImg}>
                                    <img src={defaultHoverFrameIcon} alt="defaultHoverFrameIcon" />
                                </div>
                            }
                        </div>
                    ))}
                </>
            );
        }

        return reviewImages.map((image, index) => (
            <div key={index} className={cx(s.orderUploadPreviewImgItem, 'svgImg')}>
                <div
                    className={s.orderUploadPreviewImg}
                    onClick={() => handleClick(index)}
                    style={{
                        backgroundImage: `url(${api.apiEndpoint + reviewImageUploadDir + 'medium_' + image.imageName})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}

                />
                {!isBooking && <div
                    className={cx(s.orderUploadPreviewImgRemoveIcon, 'orderUploadPreviewImgRemoveIconRtl')}
                    onClick={() => handleRemoveImage(image.imageName)}
                >
                    <img src={removeIcon} alt="removeIcon" />
                </div>}
            </div>
        ));
    };

    const handleRemoveImage = (imageName) => {
        removeReviewImage(data?.result?.id, imageName)
    }

    return (
        <Form>
            <div className={cx(bt.commonViewBookingHeading, bt.space3)}>
                {isBillingPage ? (
                    <FormattedMessage {...messages.billingDetails} />
                ) : isBooking ? (
                    <FormattedMessage {...messages.bookingDetails} />
                ) : (
                    <FormattedMessage {...messages.reviewYourRequest} />
                )}
            </div>

            {(data?.result?.orderItemsList?.length > 0) && (
                <>
                    <div className={s.orderCardListContainer}>
                        {data?.result?.orderItemsList?.length > 0 && data?.result?.orderItemsList?.map((item, index) => {
                            return (
                                <div key={index}>
                                    {reviewPage ? <OrderItems
                                        key={index}
                                        orderIndex={index}
                                        data={item}
                                        multiplierValue={item?.multiplierValue}
                                        basePrice={isOrderPage ? item?.subCategoryBasePrice : item?.baseFare}
                                        totalQuantities={item?.totalQuantity}
                                        image={item?.subCategoryDetails?.image}
                                        name={item?.subCategoryDetails?.name}
                                        pricingType={pricingType}
                                        categoryId={data?.result?.categoryDetails?.id}
                                        currency={item?.currency}
                                        isLastOrderItem={data?.result?.orderItemsList?.length === 1 ? true : false}

                                    /> : <OrderAccordionItems
                                        key={index}
                                        orderIndex={index}
                                        data={data?.result}
                                        name={item?.subCategoryDetails?.name}
                                        image={item?.subCategoryDetails?.image}
                                        pricingType={pricingType}
                                        basePrice={item?.baseFare}
                                        currency={item.currency}
                                        workLogHistory={item?.workLogHistory}
                                        workDuration={item?.workDuration}
                                        totalQuantity={item?.totalQuantity}
                                        isBooking={isBooking}
                                        id={id}
                                        socket={socket}
                                        refetch={refetch}
                                    />
                                    }
                                </div>
                            )
                        })}
                    </div>
                    <hr className={bt.sectionDividerBorder} />
                </>
            )}
            {
                isBooking && <>
                    <div>
                        <div className={cx(s.orderLocationBox, 'svgImg')}>
                            <img src={defaultDateIcon} alt="defaultDateIcon" />
                            <span className={bt.commonViewBookingSubHeading}>
                                <FormattedMessage {...messages.dateAndTime} />
                            </span>
                        </div>
                        <div className={cx(bt.fontWeight400, bt.commonSize16, bt.primaryColor, bt.textAlignStart)}>{createdAt}</div>
                    </div>
                    <hr className={bt.sectionDividerBorder} />
                </>
            }
            <div>
                <div className={cx(s.orderLocationBox, 'svgImg')}>
                    <img src={locationIcon} alt="locationIcon" />
                    <span className={bt.commonViewBookingSubHeading}>
                        <FormattedMessage {...messages.locationName} />
                    </span>
                </div>
                <div className={cx(bt.fontWeight400, bt.commonSize16, bt.primaryColor, bt.textAlignStart)}>{dropLocation}</div>
            </div>
            {
                !isBooking ? <div>
                    <hr className={bt.sectionDividerBorder} />
                    <Field
                        name="description"
                        placeholder={formatMessage(messages.describeWorkText)}
                        component={InputFieldComponent}
                        label={formatMessage(messages.describeWorkLabel)}
                        inputClass={bt.formTextArea}
                        componentClass={"textarea"}
                        labelClass={cx(bt.commonViewBookingSubHeading, bt.space2)}
                    />
                </div> : (description ?
                    <div>
                        <hr className={bt.sectionDividerBorder} />
                        <div className={cx(bt.commonViewBookingSubHeading, bt.space2)}>
                            <FormattedMessage {...messages.description} />
                        </div>
                        <ShowDescription description={description} count={250} />
                    </div> : '')
            }
            <div>
                {
                    !isBooking && isJobPhotoRequired ? (
                        <div className={cx(bt.commonViewBookingSubHeading, bt.space2, bt.spaceTop3)}>
                            <FormattedMessage {...messages.uploadPhotosText} />
                        </div>
                    ) : (
                        reviewImages.length > 0 && (
                            <>
                                <hr className={bt.sectionDividerBorder} />
                                <div className={cx(bt.commonViewBookingSubHeading, bt.space2)}>
                                    <FormattedMessage {...messages.photos} />
                                </div>
                            </>
                        )
                    )
                }
                <div className={s.orderUploadImgContainer}>
                    {
                        !isBooking && isJobPhotoRequired && <BookingReviewImageUpload
                            orderId={data?.result?.id}
                            postUrl={api.apiEndpoint + '/uploadReviewPhoto'}
                            loaderName={'reviewImageLoader'}
                            loader={reviewImageLoader}
                            imageSrc={reviewImage ? api.apiEndpoint + reviewImageUploadDir + 'medium_' + reviewImage : null}
                            fieldName={s.orderUploadImgCard}
                            iconClass={s.orderUploadImgCardPlusIcon}
                            className={cx(s.orderUploadImgCardContainer, 'svgImg')}
                            formName={'OrderDetails'}
                            reviewImages={reviewImages}
                            handleDropzone={success}
                            setImageLoader={setImageLoader}
                        />
                    }
                    {renderUploadedImages(reviewImages)}
                    {setLoader?.map((_, index) => {
                        return (
                            <div key={'loader' + index} className={s.orderUploadPreviewLoaderContainer}>
                                <Loader show={true} type="page" dropzoneLoaderClass={s.photoUpdateLoader} containerClass={'bookingPhotoUploadLoader'}>
                                    <div style={{ backgroundImage: `url(${defaultIcon})` }} />
                                </Loader>
                            </div>
                        )
                    })}
                    {isBooking && <ImageSlider
                        imageLightBox={imageLightBox}
                        closeImageLightBox={closeImageLightBox}
                        sources={sources}
                        currentImage={currentIndex + 1}
                    />}
                </div>
            </div>
        </Form>
    )
}
OrderDetails = reduxForm({
    form: 'OrderDetails', // a unique name for this form
    validate
})(OrderDetails)

const selector = formValueSelector('OrderDetails');

const mapState = (state) => ({
    reviewImage: selector(state, 'reviewImage'),
    currentIndex: state.adminModalStatus.currentIndex,
    reviewImageLoader: state.loader.reviewImageLoader,
    imageLightBox: state.adminModalStatus.imageLightBox,
});

const mapDispatch = {
    change,
    uploadReviewImage,
    removeReviewImage,
    openExactImageLightBox,
    closeImageLightBox
};
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(OrderDetails)));